import React, { useEffect, useState, Fragment } from "react";
import clsx from "clsx";
import styles from "./ArticleList.module.css";
import useMediaQuery from "hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowIcon } from "assets/icons/down-arrow-icon.svg";
import { IArticleListingTop } from "components/ArticleListing/ArticleListing.interface";

const ArticleList = ({
  allTags,
  title,
  allLabel,
  setTitle,
}: IArticleListingTop) => {
  const { t } = useTranslation();
  const { matches } = useMediaQuery("(min-width: 768px)");
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    setShowMore(matches);
  }, [matches]);

  return (
    <div className={clsx(styles.container, showMore && styles.showBorder)}>
      <div
        className={styles.mobileCont}
        onClick={() => {
          setShowMore((prev) => !prev);
        }}
      >
        <p className={styles.mobileContText}>{title.name}</p>
        <ArrowIcon className={showMore ? "rotate-180" : "rotate-0"} />
      </div>
      {showMore && (
        <div className="px-6 md:px-0">
          <p
            className={clsx(
              styles.list_items,
              styles.all_articles,
              title.name === allLabel && styles.selectedtext
            )}
            onClick={() => {
              setTitle({
                name: allLabel,
                key: "All Articles",
              });
              if (!matches) setShowMore(false);
            }}
          >
            {allLabel}
          </p>
          {allTags?.tags?.map((mainTag) => (
            <Fragment key={mainTag.key}>
              <p className={styles.list_header}>
                {mainTag?.value?.toUpperCase()}
              </p>
              {mainTag?.tags?.map((subtag) => (
                <p
                  key={subtag.key}
                  className={clsx(
                    styles.list_items,
                    title.name === subtag?.value && styles.selectedtext
                  )}
                  onClick={() => {
                    setTitle({
                      name: subtag?.value || "",
                      key: subtag?.key || "",
                    });
                    if (!matches) setShowMore(false);
                  }}
                >
                  {subtag?.value}
                </p>
              ))}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
export default ArticleList;
